import React from "react";
import { Link } from "react-router-dom";
import copyToClipboard from "copy-to-clipboard";
import toast from "react-hot-toast";
import { DOMAIN } from "../pages/NotionPage.page";
import {
  ArrowPathIcon,
  CakeIcon,
  XCircleIcon,
} from "@heroicons/react/20/solid";
import { Logo } from "./Logo";

export function EditHeader({
  path,
  editPath,
  refresh,
}: {
  path: string;
  editPath: string;
  refresh: () => Promise<void>;
}) {
  return (
    <div
      className="sticky top-0 left-0 text-gray-400 z-50 
      px-4 sm:px-6 lg:px-8 bg-gray-800 w-full flex 
      h-12 justify-between items-center"
    >
      {/* TODO: Update Logo font */}
      {/* TODO: Include Inria font */}
      <Link
        to="/"
        className="flex items-center gap-x-1 font-['Inria_Sans'] 
        text-[18px] tracking-tight text-emerald-100"
      >
        <Logo className="w-8 h-8" />
        EasyDocs
      </Link>
      <div className="flex gap-x-2 items-center">
        <div className="flex gap-x-2">
          <button
            onClick={() => {
              copyToClipboard(`${DOMAIN}${path}`);
              toast.success("Copied to clipboard");
            }}
          >
            Copy edit URL
          </button>
        </div>
        <button
          type="button"
          className="inline-flex items-center rounded-md border border-transparent
           bg-indigo-600 px-4 py-[4px] text-sm font-medium text-white shadow-sm 
           hover:bg-indigo-700 focus:outline-none 
           focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
          onClick={refresh}
        >
          <ArrowPathIcon className="-ml-1 mr-2 h-5 w-5" />
          Sync Now
        </button>
        <Link to={path}>
          <XCircleIcon className="text-gray-500 hover:text-gray-700 h-5 w-5" />
        </Link>
      </div>
    </div>
  );
}
